(() => {
  const colours = { cream: '#fff8f2', blush: '#f4e4e2', lilac: '#eee8f5' };
  const berry = '#7a3048';
  function start(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-mug-config]').textContent);
    const text = config.strings;
    const find = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const preview = find('[data-mug-preview]');
    const dialog = find('[data-review-dialog]');
    const review = find('[data-review-canvas]');
    const artwork = document.createElement('canvas');
    artwork.width = Math.round(config.width * 300);
    artwork.height = Math.round(config.height * 300);
    const state = {
      photos: [null, null], sample: null, crops: [{ zoom: 1, x: .5, y: .5 }, { zoom: 1, x: .5, y: .5 }],
      loading: [false, false], uploadVersions: [0, 0], style: 'forever', colour: 'cream', view: 'front',
      names: '', message: '', repeat: false, active: 0, version: 0, approvedVersion: -1, busy: false
    };
    function showError(message, reviewError = false) {
      const element = find(reviewError ? '[data-review-error]' : '[data-mug-error]');
      element.textContent = message;
      element.hidden = !message;
    }
    function photoAt(index) {
      return index === 1 && state.repeat ? state.photos[0] : state.photos[index];
    }
    function cropAt(index) {
      return index === 1 && state.repeat ? state.crops[0] : state.crops[index];
    }
    function cropSource(image, width, height, crop) {
      const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight) * crop.zoom;
      const sourceWidth = width / scale;
      const sourceHeight = height / scale;
      return [(image.naturalWidth - sourceWidth) * crop.x, (image.naturalHeight - sourceHeight) * crop.y, sourceWidth, sourceHeight];
    }
    function quality() {
      if (state.loading.some(Boolean)) return 'loading';
      if (!photoAt(0) || !photoAt(1)) return 'sample';
      const dpi = [0, 1].map(index => {
        const width = state.style === 'photo' ? 1110 : state.style === 'moments' ? 970 : 1000;
        const height = state.style === 'photo' ? 795 : state.style === 'moments' ? 680 : 650;
        const source = cropSource(photoAt(index).image, width, height, cropAt(index));
        return Math.min(source[2] / (config.width * width / 2700), source[3] / (config.height * height / 1050));
      });
      return Math.min(...dpi) < 150 ? 'low' : Math.min(...dpi) < 300 ? 'ok' : 'good';
    }
    function updateQuality() {
      const level = quality();
      const message = level === 'loading' ? text.loading : level === 'sample' ? text.sample_help : text['quality_' + level];
      find('[data-quality]').textContent = message;
      find('[data-quality]').dataset.level = level;
      return level;
    }
    function rounded(ctx, x, y, w, h, r) {
      ctx.beginPath(); ctx.roundRect(x, y, w, h, r);
    }
    function drawArtwork() {
      const ctx = artwork.getContext('2d');
      ctx.save(); ctx.clearRect(0, 0, artwork.width, artwork.height);
      ctx.scale(artwork.width / 2700, artwork.height / 1050);
      ctx.fillStyle = colours[state.colour]; ctx.fillRect(0, 0, 2700, 1050);
      [0, 1].forEach(index => {
        const x = index * 1350;
        const selected = photoAt(index);
        const image = selected?.image || state.sample;
        const crop = selected ? cropAt(index) : { zoom: 1, x: index ? .62 : .4, y: .15 };
        let box = { x: x + 175, y: 190, w: 1000, h: 650 };
        if (state.style === 'moments') box = { x: x + 190, y: 130, w: 970, h: 680 };
        if (state.style === 'photo') box = { x: x + 120, y: 90, w: 1110, h: 795 };
        ctx.fillStyle = '#fffdf9'; ctx.fillRect(box.x - 23, box.y - 23, box.w + 46, box.h + 46);
        if (image) {
          const source = cropSource(image, box.w, box.h, crop);
          ctx.save(); rounded(ctx, box.x, box.y, box.w, box.h, state.style === 'forever' ? 180 : 4); ctx.clip();
          ctx.drawImage(image, ...source, box.x, box.y, box.w, box.h); ctx.restore();
        }
        ctx.fillStyle = berry; ctx.textAlign = 'center';
        if (state.style === 'forever') {
          ctx.font = 'italic 55px Georgia,serif'; ctx.fillText(text.style_forever.toLowerCase(), x + 675, 118, 1100);
        }
        const names = state.names || (!state.photos.some(Boolean) ? 'Aanya & Arjun' : '');
        const message = state.message || (!state.photos.some(Boolean) ? text.message_placeholder.replace(/^e\.g\.\s*/, '') : '');
        ctx.font = state.style === 'moments' ? 'italic 55px Georgia,serif' : '700 52px Georgia,serif';
        if (names) ctx.fillText(names, x + 675, 933, 1130);
        if (message) { ctx.font = '29px Arial,sans-serif'; ctx.fillText(message, x + 675, 996, 1160); }
      });
      ctx.restore();
    }
    function bodyPath(ctx) {
      ctx.beginPath(); ctx.moveTo(205, 198); ctx.bezierCurveTo(205, 172, 665, 172, 665, 198);
      ctx.lineTo(652, 592); ctx.bezierCurveTo(650, 642, 219, 642, 218, 592); ctx.closePath();
    }
    function drawMug(ctx, side) {
      ctx.save();
      ctx.fillStyle = '#4b1e3014'; ctx.beginPath(); ctx.ellipse(450, 662, 258, 23, 0, 0, Math.PI * 2); ctx.fill();
      const handleX = side === 'back' ? 205 : 665;
      ctx.save(); ctx.translate(handleX, 0); if (side === 'back') ctx.scale(-1, 1);
      ctx.shadowColor = '#4b1e3020'; ctx.shadowBlur = 15; ctx.shadowOffsetY = 8;
      ctx.beginPath(); ctx.moveTo(-4, 245); ctx.bezierCurveTo(190, 204, 191, 509, -4, 510);
      ctx.lineTo(-4, 456); ctx.bezierCurveTo(107, 465, 118, 284, -4, 300); ctx.closePath();
      let handleShade = ctx.createLinearGradient(0, 0, 130, 0); handleShade.addColorStop(0, '#e9e5e1'); handleShade.addColorStop(.6, '#fff'); handleShade.addColorStop(1, '#e2dcd7');
      ctx.fillStyle = handleShade; ctx.fill(); ctx.restore();
      ctx.save(); ctx.shadowColor = '#4b1e3030'; ctx.shadowBlur = 20; ctx.shadowOffsetY = 12;
      bodyPath(ctx); ctx.fillStyle = '#fdfcfb'; ctx.fill(); ctx.restore();
      ctx.save(); bodyPath(ctx); ctx.clip();
      const panel = side === 'back' ? 1350 : 0;
      const strips = 170;
      for (let n = 0; n < strips; n++) {
        const a = -.5 * Math.PI + (n / strips) * Math.PI;
        const b = -.5 * Math.PI + ((n + 1) / strips) * Math.PI;
        const left = 435 + Math.sin(a) * 229;
        const right = 435 + Math.sin(b) * 229;
        const sourceX = (panel + n / strips * 1350) / 2700 * artwork.width;
        ctx.drawImage(artwork, sourceX, 0, artwork.width / 2 / strips + .5, artwork.height, left, 256, right - left + .6, 310);
      }
      const sheen = ctx.createLinearGradient(205, 0, 665, 0);
      sheen.addColorStop(0, '#46322c30'); sheen.addColorStop(.18, '#ffffff05'); sheen.addColorStop(.5, '#ffffff16'); sheen.addColorStop(.8, '#ffffff00'); sheen.addColorStop(1, '#36231e24');
      ctx.fillStyle = sheen; ctx.fillRect(200, 190, 470, 450); ctx.restore();
      ctx.beginPath(); ctx.ellipse(435, 198, 230, 37, 0, 0, Math.PI * 2); ctx.fillStyle = '#e4dfda'; ctx.fill();
      ctx.beginPath(); ctx.ellipse(435, 194, 220, 29, 0, 0, Math.PI * 2); ctx.fillStyle = '#fffdf9'; ctx.fill();
      ctx.beginPath(); ctx.ellipse(435, 198, 202, 22, 0, Math.PI, Math.PI * 2); ctx.strokeStyle = '#d7d1cb'; ctx.lineWidth = 2; ctx.stroke();
      ctx.restore();
    }
    function drawPreview() {
      drawArtwork();
      const ctx = preview.getContext('2d'); ctx.clearRect(0, 0, preview.width, preview.height);
      if (state.view === 'wrap') {
        const height = 790 / artwork.width * artwork.height;
        ctx.fillStyle = '#4b1e3010'; ctx.fillRect(49, (760 - height) / 2 + 9, 802, height + 12);
        ctx.drawImage(artwork, 55, (760 - height) / 2, 790, height);
      } else drawMug(ctx, state.view);
      const personal = !!state.photos[0] && !!photoAt(1);
      find('[data-sample-label]').textContent = personal ? text.personal_view.toUpperCase() : text.sample_label;
      find('[data-view-caption]').textContent = text[state.view === 'wrap' ? 'full_design' : state.view];
      if (dialog.open) drawReview();
    }
    function drawReview() {
      const ctx = review.getContext('2d'); ctx.clearRect(0, 0, review.width, review.height);
      [0, 1].forEach(index => {
        ctx.save(); ctx.translate(index * 700, -8); ctx.scale(700 / 900, 700 / 900); drawMug(ctx, index ? 'back' : 'front'); ctx.restore();
        ctx.fillStyle = berry; ctx.font = '22px Arial'; ctx.textAlign = 'center'; ctx.fillText(index ? text.back : text.front, index * 700 + 350, 588);
      });
    }
    function updateOrderButton() {
      find('[data-order]').disabled = !config.enabled || !find('[data-approve]').checked || state.approvedVersion !== state.version || quality() === 'low' || state.busy;
    }
    function changed() {
      state.version++; state.approvedVersion = -1; find('[data-approve]').checked = false;
      showError(''); showError('', true); updateQuality(); drawPreview(); updateOrderButton();
    }
    function edit(index) {
      if (index === 1 && state.repeat) index = 0;
      if (!state.photos[index]) return;
      state.active = index; find('[data-crop]').hidden = false;
      find('[data-crop-title]').textContent = text.photo + ' ' + (index + 1);
      all('[data-crop-control]').forEach(control => control.value = state.crops[index][control.dataset.cropControl]);
      state.view = index ? 'back' : 'front';
      all('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === state.view)));
      drawPreview();
    }
    all('[data-photo]').forEach(input => input.addEventListener('change', async () => {
      const index = Number(input.dataset.photo);
      const file = input.files[0]; if (!file) return;
      showError('');
      const fail = message => { input.value = ''; showError(message); };
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return fail(text.bad_type);
      if (file.size > 15 * 1024 * 1024) return fail(text.bad_size);
      const version = ++state.uploadVersions[index]; state.loading[index] = true; updateQuality();
      const url = URL.createObjectURL(file);
      try {
        const image = new Image(); image.src = url; await image.decode();
        if (version !== state.uploadVersions[index]) { URL.revokeObjectURL(url); return; }
        if (image.naturalWidth * image.naturalHeight > 40000000) throw new Error('large');
        if (state.photos[index]) URL.revokeObjectURL(state.photos[index].url);
        state.photos[index] = { image, file, url };
        state.crops[index] = { zoom: 1, x: .5, y: .5 };
        find('[data-filename="' + index + '"]').textContent = file.name;
        find('[data-upload-card="' + index + '"]').classList.add('has-photo');
        find('[data-edit="' + index + '"]').hidden = false;
        state.loading[index] = false; changed(); edit(index);
      } catch (error) {
        URL.revokeObjectURL(url); state.loading[index] = false;
        fail(error.message === 'large' ? text.too_large : text.bad_image); updateQuality();
      }
    }));
    all('[data-edit]').forEach(button => button.addEventListener('click', () => edit(Number(button.dataset.edit))));
    all('[data-crop-control]').forEach(input => input.addEventListener('input', () => {
      state.crops[state.active][input.dataset.cropControl] = Number(input.value); changed();
    }));
    find('[data-reset]').addEventListener('click', () => { state.crops[state.active] = { zoom: 1, x: .5, y: .5 }; changed(); edit(state.active); });
    find('[data-repeat]').addEventListener('change', event => { state.repeat = event.target.checked; changed(); if (state.repeat) edit(0); });
    all('.mug-styles input').forEach(input => input.addEventListener('change', () => { state.style = input.value; changed(); }));
    ['names', 'message'].forEach(key => find('[data-' + key + ']').addEventListener('input', event => {
      state[key] = event.target.value.trim(); find('[data-' + key + '-count]').textContent = event.target.value.length + ' / ' + (key === 'names' ? 28 : 45); changed();
    }));
    all('[data-color]').forEach(button => button.addEventListener('click', () => {
      state.colour = button.dataset.color; all('[data-color]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      find('[data-color-name]').textContent = button.getAttribute('aria-label'); changed();
    }));
    all('[data-view]').forEach(button => button.addEventListener('click', () => {
      state.view = button.dataset.view; all('[data-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); drawPreview();
    }));
    find('[data-review]').addEventListener('click', () => {
      if (!photoAt(0) || !photoAt(1) || state.loading.some(Boolean)) { showError(text.need_photos); return; }
      showError(''); const level = updateQuality();
      drawReview(); find('[data-review-summary]').textContent = (state.names || text.no_names) + ' · ' + (state.message || text.no_message);
      find('[data-low-quality]').hidden = level === 'good'; find('[data-low-quality]').textContent = text['quality_' + level] || '';
      find('[data-launch-detail]').hidden = config.enabled;
      find('[data-order]').hidden = !config.enabled;
      find('[data-approve]').checked = false; state.approvedVersion = -1; updateOrderButton(); dialog.showModal();
    });
    find('[data-approve]').addEventListener('change', event => { state.approvedVersion = event.target.checked ? state.version : -1; updateOrderButton(); });
    find('[data-close-review]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    function toBlob(canvas, type = 'image/png') {
      return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('export')), type, .95));
    }
    find('[data-download]').addEventListener('click', async () => {
      try {
        const blob = await toBlob(review); const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a'); anchor.href = url; anchor.download = 'wishhappybday-mug-preview.png'; anchor.click();
        setTimeout(() => URL.revokeObjectURL(url), 30000);
      } catch { showError(text.download_error, true); }
    });
    async function png300(blob) {
      const bytes = new Uint8Array(await blob.arrayBuffer());
      const data = new Uint8Array(9); const view = new DataView(data.buffer); view.setUint32(0, 11811); view.setUint32(4, 11811); data[8] = 1;
      const chunk = new Uint8Array(21); new DataView(chunk.buffer).setUint32(0, 9); chunk.set([112, 72, 89, 115], 4); chunk.set(data, 8);
      let crc = 0xffffffff; for (const byte of chunk.subarray(4, 17)) { crc ^= byte; for (let i = 0; i < 8; i++) crc = crc & 1 ? (crc >>> 1) ^ 0xedb88320 : crc >>> 1; }
      new DataView(chunk.buffer).setUint32(17, (crc ^ 0xffffffff) >>> 0);
      const parts = [bytes.subarray(0, 33), chunk];
      for (let offset = 33; offset < bytes.length;) {
        const length = new DataView(bytes.buffer, bytes.byteOffset + offset, 4).getUint32(0);
        const type = String.fromCharCode(...bytes.subarray(offset + 4, offset + 8));
        if (type !== 'pHYs') parts.push(bytes.subarray(offset, offset + length + 12));
        offset += length + 12;
      }
      return new Blob(parts, { type: 'image/png' });
    }
    find('[data-order]').addEventListener('click', async () => {
      const form = find('.mug-order-form');
      if (!config.enabled || !form || !photoAt(0) || !photoAt(1) || state.approvedVersion !== state.version || quality() === 'low' || !find('[data-approve]').checked || state.busy) return;
      state.busy = true; updateOrderButton(); showError('', true); find('[data-order]').textContent = text.adding;
      try {
        const version = state.version; drawArtwork(); drawReview();
        const [art, proof] = await Promise.all([toBlob(artwork).then(png300), toBlob(review)]);
        if (version !== state.version) throw new Error('changed');
        const id = 'M' + crypto.randomUUID().replaceAll('-', '').slice(0, 14);
        [[find('[data-art-file]'), art, id + '-print.png'], [find('[data-proof-file]'), proof, id + '-approved.png']].forEach(([input, blob, filename]) => {
          const transfer = new DataTransfer(); transfer.items.add(new File([blob], filename, { type: 'image/png' })); input.files = transfer.files;
        });
        find('[data-prop-names]').value = state.names; find('[data-prop-message]').value = state.message;
        find('[data-prop-style]').value = text['style_' + state.style] + ' / ' + text[state.colour]; find('[data-design-id]').value = id;
        HTMLFormElement.prototype.submit.call(form);
      } catch { showError(text.order_error, true); state.busy = false; updateOrderButton(); find('[data-order]').textContent = text.add_to_bag; }
    });
    const sample = new Image(); sample.crossOrigin = 'anonymous'; sample.onload = () => { state.sample = sample; drawPreview(); }; sample.onerror = () => showError(text.bad_image); sample.src = config.sample;
    drawPreview();
  }
  function init() { document.querySelectorAll('[data-whb-mug]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
